var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-4"},_vm._l((_vm.reisetermine),function(reisetermin){return _c('div',{key:reisetermin.id,staticClass:"mb-4"},[_c('h6',[_vm._v(_vm._s(reisetermin.reiseterminkuerzel))]),_c('ReiseterminViewCardFlugdaten',{attrs:{"reiseterminObj":reisetermin}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }